// extracted by mini-css-extract-plugin
export var buttonHide = "blog-references-module--buttonHide--2e701";
export var buttonShow = "blog-references-module--buttonShow--3576b";
export var expanded = "blog-references-module--expanded--eb4fc";
export var mobile = "blog-references-module--mobile--67e73";
export var wrapper = "blog-references-module--wrapper--618a6";